
import React, { Component } from 'react';
import { connect } from 'react-redux'

import CheckBoxComponent from './CheckBoxComponent';
import SelectComponent from './SelectComponent';

var translator = require('../../utils/translator/translator');
var displaySettingsUtils = require('../../utils/domain/settings/displaySettingsUtils');


class DisplaySettingsView extends Component 
{
    render()
    {
        return <div>
                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return displaySettingsUtils.getDisplayInternalNotes();
                            }}
                            revertValue={()=>
                            {
                                displaySettingsUtils.setDisplayInternalNotes(!displaySettingsUtils.getDisplayInternalNotes());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("display_internal_notes")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_selecting_this_option_staff_can_enter_internal_notes_for_an_order")
                            }}>

                        </CheckBoxComponent>
                    </div>
                    
                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return displaySettingsUtils.getDisplayStorefrontSelection();
                            }}
                            revertValue={()=>
                            {
                                displaySettingsUtils.setDisplayStorefrontSelection(!displaySettingsUtils.getDisplayStorefrontSelection());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("display_storefront_selection")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_selecting_this_option_staff_can_switch_between_storefronts")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return displaySettingsUtils.getDisplayLoginStaffName();
                            }}
                            revertValue={()=>
                            {
                                displaySettingsUtils.setDisplayLoginStaffName(!displaySettingsUtils.getDisplayLoginStaffName());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("display_staff_name")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_selecting_this_option_logged_in_staff_name_will_be_displayed")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return displaySettingsUtils.getDisplayOnScreenKeyboard();
                            }}
                            revertValue={()=>
                            {
                                displaySettingsUtils.setDisplayOnScreenKeyboard(!displaySettingsUtils.getDisplayOnScreenKeyboard());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("display_on_screen_keyboard")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("by_selecting_this_option_on_screen_keyboard__will_be_displayed")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div>
                        <CheckBoxComponent 
                            getValue={()=>
                            {
                                return displaySettingsUtils.getDisplayScreenSaver();
                            }}
                            revertValue={()=>
                            {
                                displaySettingsUtils.setDisplayScreenSaver(!displaySettingsUtils.getDisplayScreenSaver());
                            }}
                            getCaption={()=>
                            {
                                return translator.getLabel("display_screen_saver")
                            }}
                            getHints={()=>
                            {
                                return translator.getLabel("selecting_this_option_will_cause_the_system_to_show_a_screensaver_when_it_is_idle")
                            }}>

                        </CheckBoxComponent>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div style={{marginTop:'5px'}}>
                        <SelectComponent
                            getCaption={()=>{return translator.getLabel("cli_notification_position")}}
                            getHints={()=>{return translator.getLabel("please_select_the_on_screen_location_for_displaying_cli_notifications")}}
                            onSelectionChanged={(option) =>
                            {
                                displaySettingsUtils.setCliNotificationPosition(option == null ? null : option.id);
                            }}
                            options={this.getCLINotificationPositions()}
                            selectedValue={displaySettingsUtils.getCliNotificationPosition()}
                            valueFieldName="id"
                            displayFieldName="label"
                            isClearable={true}
                            multi = {false}/>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div style={{marginTop:'5px'}}>
                        <SelectComponent
                            getCaption={()=>{return translator.getLabel("order_screen")}}
                            getHints={()=>{return translator.getLabel("please_select_the_layout_you_like_to_use_when_taking_orders")}}
                            onSelectionChanged={(option) =>
                            {
                                displaySettingsUtils.setOrderScreenLayout(option.id);
                            }}displaySettingsUtils
                            options={this.getScreenLayouts()}
                            selectedValue={displaySettingsUtils.getOrderScreenLayout()}
                            valueFieldName="id"
                            displayFieldName="label"
                            multi = {false}/>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div style={{marginTop:'5px'}}>
                        <SelectComponent
                            getCaption={()=>{return translator.getLabel("menu_screen")}}
                            getHints={()=>{return translator.getLabel("please_select_the_layout_you_like_to_use_for_menu")}}
                            onSelectionChanged={(option) =>
                            {
                                displaySettingsUtils.setMenuItemLayout(option.id);
                            }}displaySettingsUtils
                            options={this.getMenuScreenLayouts()}
                            selectedValue={displaySettingsUtils.getMenuItemLayout()}
                            valueFieldName="id"
                            displayFieldName="label"
                            multi = {false}/>
                    </div>

                    <hr style={{marginTop:'30px', marginBottom:'30px'}}/>

                    <div style={{marginTop:'5px'}}>
                        <SelectComponent
                            getCaption={()=>{return translator.getLabel("modifier_screen")}}
                            getHints={()=>{return translator.getLabel("please_select_the_layout_you_like_to_use_for_modifier")}}
                            onSelectionChanged={(option) =>
                            {
                                displaySettingsUtils.setModifierLayout(option.id);
                            }}displaySettingsUtils
                            options={this.getModifierScreenLayouts()}
                            selectedValue={displaySettingsUtils.getModifierLayout()}
                            valueFieldName="id"
                            displayFieldName="label"
                            multi = {false}/>
                    </div>
                </div>
    }

    getCLINotificationPositions()
    {
        var positions = [];
        var position = {};
        position.label = translator.getLabel("bottom_right");
        position.id = "BottomRight";
        positions.push(position);

        position = {};
        position.label = translator.getLabel("bottom_left");
        position.id = "BottomLeft";
        positions.push(position);

        position = {};
        position.label = translator.getLabel("top_right");
        position.id = "TopRight";
        positions.push(position);

        position = {};
        position.label = translator.getLabel("top_left");
        position.id = "TopLeft";
        positions.push(position);

        return positions;
    }

    getScreenLayouts()
    {
        var layouts = [];
        var layout = {};
        layout.label = translator.getLabel("classic");
        layout.id = "Classic";
        layouts.push(layout);

        layout = {};
        layout.label = translator.getLabel("simple");
        layout.id = "Simple";
        layouts.push(layout);
        
        return layouts;
    }

    getMenuScreenLayouts()
    {
        var layouts = [];
        var layout = {};
        layout.label = translator.getLabel("layout_with_images");
        layout.id = "LayoutWithImages";
        layouts.push(layout);

        layout = {};
        layout.label = translator.getLabel("layout_without_images");
        layout.id = "LayoutWithoutImages";
        layouts.push(layout);

        return layouts;
    }

    getModifierScreenLayouts()
    {
        var layouts = [];
        var layout = {};
        layout.label = translator.getLabel("layout_with_wizard");
        layout.id = "LayoutWithWizard";
        layouts.push(layout);

        layout = {};
        layout.label = translator.getLabel("layout_with_column");
        layout.id = "LayoutWithColumn";
        layouts.push(layout);

        return layouts;
    }
}

const mapStateToProps = state => 
{
    return { 
                settingsChangedTimeStamp: state.settingsChangedTimeStamp,
           }
}

export default connect(mapStateToProps)(DisplaySettingsView)